import { client } from '@/api/client';
import {
    GetUnprintedRegistrationIds,
    GetUnprintedRegistrationIdsResponse
} from '@/api/dtos';
import useSWRMutation from 'swr/mutation';

async function getUnprintedRegistrationIdsFetcher(
    _key: string,
    { arg }: { arg: GetUnprintedRegistrationIds }
): Promise<GetUnprintedRegistrationIdsResponse> {
    return (await client.get(arg)) as GetUnprintedRegistrationIdsResponse;
}

export const useGetUnprintedRegistrationIds = () => {
    const { trigger, data, error, isMutating } = useSWRMutation(
        'GetUnprintedRegistrationIds',
        getUnprintedRegistrationIdsFetcher
    );

    return {
        getUnprintedRegistrationIds: trigger,
        data,
        error,
        pending: isMutating,
    };
};

export default useGetUnprintedRegistrationIds;
